<template>
<v-layout row wrap justify-center align-center no-gutters class=" cont-sec-transacciones">
  <v-flex xs12 sm9 class="ma-0 py-8 px-3">
    <v-row class="no-gutters py-10">
      <v-col cols="12" class="cont-titulo-white text-left mb-4">
        <h1> {{itemsec.titulo}} </h1>
      </v-col>
      <v-col cols="12" sm="9" class="text-left mt-4" >
        <div class="btn-transaccion d-flex justify-start align-center my-1"
          v-for="(tran, idx) in transacciones" :key="'tran-'+idx"
          >
          <div class="logo-entidad">
            <v-icon color="primary">{{tran.icon}}</v-icon>
          </div>
          <h3>{{tran.name}}</h3>
          <v-btn small color="primary"
          v-if="tran.estado"
          @click="irContenido(tran.url)"
          >Ir <v-icon right>mdi-arrow-right</v-icon> </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-flex>

</v-layout>
</template>
<script>
import axios from 'axios'
export default {
  name: 'secTransacciones',
  data () {
    return {
      infoActualizado: [],
      itemsec: {
        titulo: 'Estar actualizado'
      },
      transacciones: [
        {
          name: 'Estados de emergencia',
          url: 'estaractualizado',
          icon: 'mdi-alert',
          estado: true
        },
        {
          name: 'Sistema de Información y Gestión del Empleo Público',
          url: 'solicitudsPqr',
          icon: 'mdi-chat',
          estado: false
        }

      ]
    }
  },
  async mounted () {
    await axios
      .get('' + this.$store.state.rutaApi + 'estar_actualizado')
      .then(response => (this.infoActualizado = response.data))
    // console.log(this.infoActualizado )
    this.transacciones[0].name = this.infoActualizado[0].titulo_contenido
  },
  methods: {
    irContenido (val) {
      this.$router.replace({ name: val })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../scss/globals.scss';
.cont-sec-transacciones{
  background: url('../assets/img/back-sec-actualizado.png');
  // background-attachment: fixed;
  background-size: cover;
  background-position: center;
  border-radius: 0px 20px 20px 0px;
}
.btn-transaccion{
  padding: 4px;
  background-color:#FFFFFF;
  border-radius: 5px;
  border:solid #2B5AC4  1px;
  margin-left: 15px;
  h3{
    margin: 0px;
    padding: 0px;
    color: #2B5AC4;
    font-size: 1em;
    text-align: left;
    line-height: 1.1em;
    margin-left: 5px;
    width: calc(100% - 60px);
  }
  .logo-entidad{
    border: #2B5AC4 solid 2px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    width: 60px;
    height: 60px;
    background: white;
    margin-left: -30px;
  }
}

</style>
